import React from 'react'
import clsx from 'clsx'
import { LikeSvg, DisLikeSvg } from '../Rating/LikeDislikeSvg'
const iconComponent = {
  like: LikeSvg,
  dislike: DisLikeSvg,
}

const renderName = (name, image) => (
  <span className="formz-radio-input-label-text">
    {image && (
      <img
        src={image}
        style={{
          width: '100px',
          height: '100px',
          objectFit: 'contain',
          margin: '0 10px',
        }}
        alt=""
      />
    )}
    {name && <p>{name}</p>}
  </span>
)
const renderIcon = (icon) => (
  <span className="formz-radio-input-label-svg">{iconComponent[icon]}</span>
)

const Radio = ({ value, name, icon, checked, onCheck, type, image }) => {
  if (type === 'nps')
    return (
      <div className="score-input-formz" key={value}>
        <input
          type="radio"
          checked={checked}
          id={`radio-${name || 'none'}-${value}`}
          onChange={() => onCheck(value)}
          style={{ display: 'none' }}
        />
        <label htmlFor={`radio-${name || 'none'}-${value}`}>
          {name && renderName(name)}
        </label>
      </div>
    )
  return (
    <div
      className={clsx({
        'formz-radio': true,
        'has-no-label': !name,
      })}
      key={value}
    >
      <input
        type="radio"
        checked={checked}
        id={`radio-${name || 'none'}-${value}`}
        onChange={() => onCheck(value)}
      />
      <label
        htmlFor={`radio-${name || 'none'}-${value}`}
        className={clsx({
          'formz-radio-label': icon ? false : true,
          'has-no-label': !name,
        })}
      >
        {/* {icon ? renderIcon(icon): name && renderName(name)} */}
        {icon && renderIcon(icon)}
        {(name || image) && renderName(name, image)}
      </label>
    </div>
  )
}

export default Radio
